import { render, staticRenderFns } from "./about-us-news.vue?vue&type=template&id=4f72c57f&scoped=true&"
import script from "./about-us-news.vue?vue&type=script&lang=js&"
export * from "./about-us-news.vue?vue&type=script&lang=js&"
import style0 from "./about-us-news.vue?vue&type=style&index=0&id=4f72c57f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f72c57f",
  null
  
)

export default component.exports